import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';

import { FormGroup, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';

import {ActivatedRoute, Router, ParamMap} from '@angular/router';

import { UserInfoService } from '../../shared/user-info.service'

import {ApiService} from '../../shared/api-service.service'

@Component({
  selector: 'app-initial-form',
  templateUrl: './initial-form.component.html',
  styleUrls: ['./initial-form.component.css']
})
export class InitialFormComponent implements OnInit {

  @ViewChild('firstNameLabel',{static:true}) private firstNameLabel;
  @ViewChild('lastNameLabel',{static:true}) private lastNameLabel;
  @ViewChild('emailLabel',{static:true}) private emailLabel;
  @ViewChild('phoneLabel',{static:true}) private phoneLabel;
  @ViewChild('spouseFirstNameLabel',{static:true}) private spouseFirstNameLabel;
  @ViewChild('spouseLastNameLabel',{static:true}) private spouseLastNameLabel;
  @ViewChild('spouseEmailLabel',{static:true}) private spouseEmailLabel;
  @ViewChild('spousePhoneLabel',{static:true}) private spousePhoneLabel;
  @ViewChild('employmentLabel',{static:true}) private employmentLabel;
  @ViewChild('martialStatusLabel',{static:true}) private martialStatusLabel;
  @ViewChild('foundLabel',{static:true}) private foundLabel;
  @ViewChild('leaseLabel',{static:true}) private leaseLabel;

  @ViewChild('spouseDiv',{static:true}) private spouseDiv;
  @ViewChild('LOPDiv',{static:true}) private lopDiv;


  registerForm = new FormGroup({
    firstName: new FormControl('',Validators.required),
    lastName: new FormControl('',Validators.required),
    email: new FormControl('',Validators.required),
    phone: new FormControl('',Validators.required),
    spouseFirstName: new FormControl('',Validators.required),
    spouseLastName: new FormControl('',Validators.required),
    spouseEmail: new FormControl('',Validators.required),
    spousePhone: new FormControl('',Validators.required),
    employment: new FormControl('',Validators.required),
    maritalStatus: new FormControl('',Validators.required),
    found: new FormControl('',Validators.required),
    leaseProfessional: new FormControl('',Validators.required),
  });

  feedback = ""
  isMarried = false
  wasFoundByLOP = false
  lopList = []

  constructor(private router: Router, private aRoute : ActivatedRoute, private cloudService: ApiService ) { }

  ngOnInit() {
    //this.firstNameLabel.nativeElement.style.color = 'red';
    this.getLopsFromCloud()
    this.pingUpdateLop()
  }

  onSubmit(){
    console.log("ahaa")
    var cleanForm = true
    this.resetFormIdentifiers()
    var fName = this.registerForm.get('firstName').value
    var lName = this.registerForm.get('lastName').value
    var email = this.registerForm.get('email').value
    var phone = this.registerForm.get('phone').value
    var spouseFName = this.registerForm.get('spouseFirstName').value
    var spouseLName = this.registerForm.get('spouseLastName').value
    var spouseEmail = this.registerForm.get('spouseEmail').value
    var spousePhone = this.registerForm.get('spousePhone').value
    var spouseJSONStr = spouseFName + " " + spouseLName + " phone: " + spousePhone + " email: " + spouseEmail
    var employment = this.registerForm.get('employment').value
    var maritalStatus = this.registerForm.get('maritalStatus').value
    var found = this.registerForm.get('found').value
    var leaseProfessional = this.registerForm.get('leaseProfessional').value
    console.log("maritalStatus - " + maritalStatus)
    var myJson = {
      "first_name":fName,
      "last_name":lName,
      "email":email,
      "phone":phone,
      "spose_details": spouseJSONStr,
      "spouse_first_name": spouseFName,
      "spouse_last_name":spouseLName,
      "spouse_email":spouseEmail,
      "spouse_phone":spousePhone,
      "employment":employment,
      "maritalStatus":maritalStatus,
      "found":found,
      "leaseProfessional":leaseProfessional,
      "paid":"no",
    }
    if(fName.length < 2){

      this.feedback = "First Name is Required"
      cleanForm = false
      this.firstNameLabel.nativeElement.style.color = 'red';

    } 
    if(lName.length < 2){

      this.feedback = "Last Name is Required"
      cleanForm = false
      this.lastNameLabel.nativeElement.style.color = "red"
      
    } 
    if(email.length < 1){

      this.feedback= "Email is Required";
      cleanForm = false
      this.emailLabel.nativeElement.style.color = "red"

    }
    if(email.length < 6 || !email.includes("@")){

      this.feedback= "Invalid email!";
      cleanForm = false
      this.emailLabel.nativeElement.style.color = "red"

    }
    if(!this.isPhoneNum(phone)){

      this.feedback= "Invalid phone, format like (1112223333), \n (111 222 3333), \n or (111-222-3333)";
      cleanForm = false
      this.phoneLabel.nativeElement.style.color = "red"
      
    }
    if(employment.length < 1){
      
      this.feedback= "You Must Select Your Employment Type";
      cleanForm = false
      this.employmentLabel.nativeElement.style.color = "red"

    }
    if(maritalStatus.length < 1){
      
      this.feedback= "You Must Select Your Marital Status";
      cleanForm = false
      this.martialStatusLabel.nativeElement.style.color = "red"

    }
    if(maritalStatus == "married"){
      console.log("checking spouse details")
      console.log()
      if(spouseFName.length < 2){

        this.feedback = "Spouse First Name is Required"
        cleanForm = false
        this.spouseFirstNameLabel.nativeElement.style.color = 'red';
  
      } 
      if(spouseLName.length < 2){
  
        this.feedback = "Spouse Last Name is Required"
        cleanForm = false
        this.spouseLastNameLabel.nativeElement.style.color = "red"
        
      } 
      if(spouseEmail.length < 1){
  
        this.feedback= "Spouse Email is Required";
        cleanForm = false
        this.spouseEmailLabel.nativeElement.style.color = "red"
  
      }
      if(spouseEmail.length < 6 || !spouseEmail.includes("@")){
  
        this.feedback= "Invalid spouse email!";
        cleanForm = false
        this.spouseEmailLabel.nativeElement.style.color = "red"
  
      }
      if(!this.isPhoneNum(spousePhone)){

        this.feedback="Invalid Spouse phone, format like (1112223333), \n (111 222 3333), \n or (111-222-3333)";
        cleanForm = false
        this.spousePhoneLabel.nativeElement.style.color = "red"

      }
    }
    if(found.length < 1){

      this.feedback= "Please Select How You Found US";
      cleanForm = false
      this.foundLabel.nativeElement.style.color = "red"

    }
    if(found == "lease option proffesional" && leaseProfessional.length < 1){
      this.feedback = "Please Select Which Lease Professional Assisted You"
      cleanForm = false
      this.leaseLabel.nativeElement.style.color = "red"
    }
    if(cleanForm){
      this.feedback = "Submitted"
      this.registerRedirect(myJson)
    }

  }


  onChange(deviceValue) {
    if(deviceValue == "married"){
      this.spouseDiv.nativeElement.style.visibility = "Visible"
      this.spouseDiv.nativeElement.style.height = "auto"
      this.spouseDiv.nativeElement.style.border = " solid black 2px"
    }else{
      this.spouseDiv.nativeElement.style.visibility = "hidden"
      this.spouseDiv.nativeElement.style.height = "0px"
      this.spouseDiv.nativeElement.style.border = "none"
    }
  }

  
  onFoundChange(deviceValue) {
    if(deviceValue == "lease option proffesional"){
      this.lopDiv.nativeElement.style.visibility = "Visible"
      this.lopDiv.nativeElement.style.height = "auto"
    }else{
      this.lopDiv.nativeElement.style.visibility = "hidden"
      this.lopDiv.nativeElement.style.height = "0px"
    }
  }


  resetFormIdentifiers(){
    this.firstNameLabel.nativeElement.style.color = "black";
    this.lastNameLabel.nativeElement.style.color = "black";
    this.emailLabel.nativeElement.style.color = "black";
    this.phoneLabel.nativeElement.style.color = "black";
    if(this.isMarried){
      this.spouseFirstNameLabel.nativeElement.style.color = "black";
    this.spouseLastNameLabel.nativeElement.style.color = "black";
    this.spouseEmailLabel.nativeElement.style.color = "black";
    this.spousePhoneLabel.nativeElement.style.color = "black";
    }
    this.employmentLabel.nativeElement.style.color = "black";
    this.martialStatusLabel.nativeElement.style.color = "black";
    this.foundLabel.nativeElement.style.color = "black";
    if(this.wasFoundByLOP){
      this.leaseLabel.nativeElement.style.color = "black";
    }
  }

   //check if string is a proper phone number
   isPhoneNum(inStr:string): boolean{
     console.log("validating phone num")
     console.log(inStr)
    if(inStr.length != 10 && inStr.length != 12){
      return false
    }
    var index = 0;
    var shouldContainBreak = (inStr.length == 12 ? true : false)
    for(let char of inStr){
     
      if((index == 3 || index == 7) && shouldContainBreak){
        if(char != "-" && char != " "){
          console.log("didnt validate when char was " + char)
          return false
        }else{
          index += 1;
          continue
        }
      }
      if(!this.charIsNum(char)){
        return false;
      }

      index += 1;
    }
    return true;
  }

  charIsNum(inStr:string){
    for(let char of inStr){
      if(char == '1'){
        return true;
      }else if(char == '2'){
        return true;
      }else if(char == '3'){
        return true;
      }else if(char == '4'){
        return true;
      }
      else if(char == '5'){
        return true;
      }else if(char == '6'){
        return true;
      }else if(char == '7'){
        return true;
      }else if(char == '8'){
        return true;
      }else if(char == '9'){
        return true;
      }else if(char == '0'){
        return true;
      }
    }
    return false;
  }

  //TODO: add to leads here
  registerRedirect(leadData:any){
    this.feedback = "One Moment"
    this.cloudService.cloudPost(JSON.stringify(leadData)).subscribe(packet => {
      localStorage.setItem("leadData",JSON.stringify(leadData))
      UserInfoService.setData(leadData)
      console.log(UserInfoService.getData())
      this.router.navigate(['authorizePayment']);
    });
    
  }

  getLopsFromCloud(){
    this.cloudService.getLops().subscribe(packet => {
      
      // console.log("lop data --")
      var res = packet.lops.toString().split(",");
      // console.log(res)
      this.lopList = res
    })
  }

  pingUpdateLop(){
    this.cloudService.updateLops().subscribe(packet => {
      console.log("update packet?")
      console.log(packet)
    })
  }

}
